import { ButtonContext } from '@zapier/design-system';
import clsx from 'clsx';
import { CSSProperties, ReactNode, useMemo } from 'react';
import styles from './Footer.module.scss';

type ModalContentFooterProps = {
  /** The children to render inside the component. */
  children: ReactNode;
  /** Optional property for overriding styles. */
  className?: string;
  /** Optional property for overriding styles. */
  style?: CSSProperties;
};

/**
 * The dialog footer, which should contain up to two buttons:
 * - an optional secondary button
 * - an required primary button
 */
export const ModalDialogFooter = ({
  children,
  className,
  style,
}: ModalContentFooterProps) => {
  const contextValue = useMemo(() => ({ size: 'medium' as const }), []);

  return (
    <footer
      className={clsx(styles.modalDialogFooter, className)}
      data-zds
      style={style}
    >
      <ButtonContext.Provider value={contextValue}>
        {children}
      </ButtonContext.Provider>
    </footer>
  );
};
